import { httpClient } from '@internal/api/system';
import { mutationEndpoint } from '@internal/api/system/endpoints';

const startCoderbyteTest = mutationEndpoint({
  actionName: 'startCoderbyteTest',
  mutationKey: ['start-coderbyte-test'],
  mutationFn: ({ apiKey, role }: { apiKey: string; role: string }) =>
    httpClient.auto<string>({
      url: `/api/coderbyte/invite-url?role=${encodeURIComponent(role)}`,
      method: 'GET',
      headers: {
        'auth-key': apiKey,
      },
    }),
});

export { startCoderbyteTest };
